import { render, staticRenderFns } from "./WillBeneficiariesDivorcedYN.vue?vue&type=template&id=216af7d3"
import script from "./WillBeneficiariesDivorcedYN.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesDivorcedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports